var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"start-page"},[_c('div',{staticClass:"bg-wrap",on:{"click":_vm.goHome}},[_c('footer',{staticClass:"copyright"},[_vm._v(" Copyright ©湖北省人才发展集团有限公司. All Rights Reserved ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }